import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchGetVendres(action) {
	try {
		const result = yield fromApi.vendresGet(action.page, action.range, action.cat, action.dep).then((data) => {
			return data;
		});
		yield put({type: 'GET_VENDRES_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetVendre(action) {
	try {
		const result = yield fromApi.paGet(action.payload).then((data) => {
			return data;
		});
		yield put({type: 'GET_VENDRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutVendre(action) {
	try {
		const result = yield fromApi.paPut(action.payload, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_VENDRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* watchDelVendre(action) {
	try {
		const result = yield fromApi.paDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_VENDRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* vendre() {
	yield takeLatest('GET_VENDRES_SAGAS', watchGetVendres);
	yield takeLatest('GET_VENDRE_SAGAS', watchGetVendre);
	yield takeLatest('PUT_VENDRE_SAGAS', watchPutVendre);
	yield takeLatest('DEL_VENDRE_SAGAS', watchDelVendre);
}

export default function* rootSaga() {
	yield all([vendre()]);
}
